import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

import Spacer from "components/Spacer";
import PercentageIndicator from "components/visuals/PercentageIndicator";

import { selectors } from "modules/customer/insights/portfolio/performanceDrivers/storeSize";

const SalesPerSquareFootVariance = () => {
    const salesPerSquareFootVariance = useSelector(state => selectors.salesPerSquareFootVariance(state));
    const { loading, error, value } = salesPerSquareFootVariance;
    const label = "% variance from median";

    return (
        <Box display="flex" data-cy="sales-per-square-foot-variance">
            <Typography variant="body1">{label}</Typography>
            <Spacer />
            <PercentageIndicator loading={loading} error={error} align="right" showIndicator={false} value={value} />
        </Box>
    );
};

export default SalesPerSquareFootVariance;
